<template>
    <div class="homeBox">
        <!-- <iframe src="https://service.dy-gj.cn/pingjiangmain/" width="100%" height="100%" border="0" v-if="pid == 61"></iframe> -->
        <iframe src="https://html.dy-gj.cn/pj/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 61"></iframe>
        
        <!-- <iframe src="https://service.dy-gj.cn/luoningmain/" width="100%" height="100%" border="0" v-if="pid == 66"></iframe> -->
        <iframe src="https://html.dy-gj.cn/LN/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 66"></iframe>
        
        <!-- <iframe src="https://service.dy-gj.cn/hamimain/" width="100%" height="100%" border="0" v-if="pid == 69"></iframe> -->
        <iframe src="https://html.dy-gj.cn/hm/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 69"></iframe>

        <!-- <iframe src="https://service.dy-gj.cn/taianmain/" width="100%" height="100%" border="0" v-if="pid == 77"></iframe> -->
        <iframe src="https://html.dy-gj.cn/ta/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 77"></iframe>
        
        <!-- <iframe src="https://service.dy-gj.cn/pananmain/" width="100%" height="100%" border="0" v-if="pid == 89"></iframe> -->
        <iframe src="https://html.dy-gj.cn/pa/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 89"></iframe>
        
        <!-- <iframe src="https://service.dy-gj.cn/yuanqumain/" width="100%" height="100%" border="0" v-if="pid == 90"></iframe> -->
        <iframe src="https://html.dy-gj.cn/yq/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 90"></iframe>
        
        <!-- <iframe src="https://service.dy-gj.cn/hunyuanmain/" width="100%" height="100%" border="0" v-if="pid == 99"></iframe> -->
        <iframe src="https://html.dy-gj.cn/hy/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 99"></iframe>
        
        <!-- <iframe src="https://service.dy-gj.cn/tongchengmain/" width="100%" height="100%" border="0" v-if="pid == 100"></iframe> -->
        <iframe src="https://html.dy-gj.cn/tc/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 100"></iframe>
        
        <!-- <iframe src="https://service.dy-gj.cn/qujiangmain/" width="100%" height="100%" border="0" v-if="pid == 117"></iframe> -->
        <iframe src="https://html.dy-gj.cn/qj/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 117"></iframe>
        
        <!-- <iframe src="https://service.dy-gj.cn/tuanfengmain/" width="100%" height="100%" border="0" v-if="pid == 112"></iframe> -->
        <iframe src="https://html.dy-gj.cn/tf/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 112"></iframe>
        
        <!-- <iframe src="https://service.dy-gj.cn/tuxikoumain/" width="100%" height="100%" border="0" v-if="pid == 72"></iframe> -->
        <iframe src="https://html.dy-gj.cn/txk/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 72"></iframe>
        
        <!-- <iframe src="https://service.dy-gj.cn/shangzhimain/" width="100%" height="100%" border="0" v-if="pid == 122"></iframe> -->
        <iframe src="https://html.dy-gj.cn/sz/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 122"></iframe>
        
        <!-- <iframe src="https://service.dy-gj.cn/yunfumain/" width="100%" height="100%" border="0" v-if="pid == 101"></iframe> -->
        <iframe src="https://html.dy-gj.cn/yf/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 101"></iframe>
        
        <!-- <iframe src="https://service.dy-gj.cn/jiaohemain/" width="100%" height="100%" border="0" v-if="pid == 133"></iframe> -->
        <iframe src="https://html.dy-gj.cn/jh/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 133"></iframe>
        
        <!-- <iframe src="https://service.dy-gj.cn/qiannanmain/" width="100%" height="100%" border="0" v-if="pid == 154"></iframe> -->
        <iframe src="https://html.dy-gj.cn/qn/WebGL/index.html" width="100%" height="100%" border="0" v-if="pid == 154"></iframe>
    </div>
</template>

<script>
import { getUserInfo } from '@/api/common'

export default {
    name: "home",
    data() {
        return {
            pid: 0,
        };
    },
    mounted(){
        this.getUser()
    },
    methods: {
        getUser(){
            let u_token = sessionStorage.getItem("U_TOKEN")
            if(u_token == null){
                u_token = ""
            }
            getUserInfo(u_token).then(res=>{
                if(res.code == 1){
                    this.pid = res.data.org_pid
                }
            })
        },
    }
};
</script>
<style lang="less">
    .homeBox {
        width: 100%;
        height: 100%;
    }
</style>
